import SeriesIntro from "../../../../src/content/blog/2-MachineLearning/NNFromScratch/SeriesIntro.mdx";
import * as React from 'react';
export default {
  SeriesIntro,
  React
};